import { useState, useEffect } from "react";
import { useParams, Navigate, useNavigate } from "react-router-dom";
import DeleteModal from "../../common/commonModal/DeleteModal";
import ReactNotifications from "../../common/reactNotifications/ReactNotifications";
import * as utilConstants from "../../../utils/constants/utilsConstants";
import { acceptInvitationOnMemberEnd } from "../../../api/companyStructureApi/companyStructureApi";

const Invitation = () => {
    const [show, setShow] = useState(false);
    const { token } = useParams();
    const navigate = useNavigate();
    const [shouldRedirect, setShouldRedirect] = useState(false);

    const handleAccept = () => {
        if (token) {
            acceptInvitationOnMemberEnd(token, (res) => {
                if (res?.status === true) {
                    ReactNotifications(res?.message, utilConstants.sucessState200);
                    setShow(false);
                    navigate('/company/team-hierarchy');
                } else {
                    ReactNotifications(res?.data?.message, utilConstants.getErrorStatus);
                }
            })
        }
    };

    const handleIgnore = () => {
        console.log("Invitation ignored with token:", token);
        setShow(false);
        setShouldRedirect(true);
    };

    useEffect(() => {
        if (!token) {
            setShouldRedirect(true);
        } else {
            setShow(true);
        }
    }, [token]);

    if (shouldRedirect) {
        return <Navigate to="/dashboard" replace />;
    }

    const modalMessage = "You have been invited to join a team. Do you want to accept this invitation?";

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-50">
            <DeleteModal
                show={show}
                onClose={handleIgnore}
                onConfirm={handleAccept}
                confirmText="Accept"
                cancelText="Ignore"
                cancelButtonStyle="!bg-white text-black border border-gray-300 hover:!bg-gray-100 py-2 px-6 font-semibold transition-colors"
                confirmButtonStyle="!bg-[#AEF468] !border-none text-black hover:!bg-[#9DE357] py-2 px-6 font-semibold transition-colors"
                title="Accept Team Invitation"
                message={modalMessage}
            />
        </div>
    );
};

export default Invitation;